import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "gfu-embed gfu-embed--1x1 _flex-basis-50" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "_flex-basis-50" }
const _hoisted_4 = { class: "_pa-4" }
const _hoisted_5 = {
  class: "gfu-heading",
  "data-qa": "product-name"
}
const _hoisted_6 = {
  class: "_mt-1 _tc--light",
  "data-qa": "quantity-added"
}
const _hoisted_7 = { class: "_flex _mt-3" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_add_product_to_cart_installments_information = _resolveComponent("add-product-to-cart-installments-information")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_product_recommendation_slider = _resolveComponent("product-recommendation-slider")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    title: $options.headerText,
    icon: "check",
    "is-visible": true,
    "data-qa": "added-to-order-modal"
  }, _createSlots({
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "actions", {
        close: $options.close,
        submit: $options.submit
      }, () => [
        _createElementVNode("a", {
          href: "",
          class: "gfu-link gfu-link--accent gfu-link--inline",
          onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
          "data-qa": "modal-button:ContinueShopping"
        }, _toDisplayString(_ctx.Resources.ProjectHome.AddToCartSuccessContinueBrowsingButton), 1 /* TEXT */),
        _createVNode(_component_tooltip, {
          enabled: !$options.canProceedToCheckout,
          text: $options.canProceedToCheckoutErrorMessage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_button, {
              enabled: $options.canProceedToCheckout,
              theme: "accent",
              width: "wide",
              onClick: _withModifiers($options.submit, ["prevent"]),
              "data-qa": "modal-button:Checkout"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.submitButtonText), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["enabled", "onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["enabled", "text"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass($options.cardClasses)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "gfu-embed__item _rounded--common",
            src: $props.imageUrl,
            alt: $props.productName
          }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString($props.productName), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_6, _toDisplayString($options.quantityLabel), 1 /* TEXT */)
          ])
        ])
      ], 2 /* CLASS */),
      ($options.shouldShowInstallmentsInformation)
        ? (_openBlock(), _createBlock(_component_add_product_to_cart_installments_information, {
            key: 0,
            "data-qa": "stretch-pay-info"
          }))
        : _createCommentVNode("v-if", true),
      (!$options.isLegacy)
        ? (_openBlock(), _createBlock(_component_product_recommendation_slider, {
            key: 1,
            section: "upsells-success-modal",
            "project-id": $options.projectId
          }, null, 8 /* PROPS */, ["project-id"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_progress_overlay, {
        visible: _ctx.isProcessing,
        sticky: true
      }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.isPledgePlaced)
      ? {
          name: "additionalInfo",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_base_icon, {
                name: "circle-info",
                class: "_tc--accent _mr-1"
              }),
              _createElementVNode("div", {
                innerHTML: _ctx.Resources.ProjectHome.AddToCartSuccessSubmitChangesHint
              }, null, 8 /* PROPS */, _hoisted_8)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]))
}